export const RETAIL_IAM_TOKEN = 'RETAIL_IAM_TOKEN'
export const RETAIL_EMAIL_TO = 'RETAIL_EMAIL_TO'
export const PNTOPBAR_ID_TOKEN = 'id_token'
export const PNTOPBAR_IAM_TOKEN = 'IAM_access_token'
